import { buildApiCall } from '@he-novation/config/apis/api-fetch';
import { API_FORMS } from '@he-novation/config/apis/form-api';
import { Form, FormWithFields } from '@he-novation/config/types/form.types';
import { FormListQuery } from '@he-novation/config/types/payloads/form.payload';

export const asyncFormsList = (workspaceName: string, target?: FormListQuery): Promise<Form[]> =>
    buildApiCall(API_FORMS.LIST)({ params: { workspaceName }, query: target });

export const asyncFormFetch = (
    workspaceName: string,
    identifier: string
): Promise<FormWithFields> =>
    buildApiCall(API_FORMS.GET)({ params: { workspaceName, identifier } });
